"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mobile = exports.mobile = "max-width: 800px";
//# sourceMappingURL=styles.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/styles.js
 ** module id = 214
 ** module chunks = 0
 **/